import Joi from "joi-browser";
import useConfigureForm from "../../useConfigureForm";
import { defaultEndFormSchema } from "../Default/useDefaultEndForm";
import { ArchiveReason, CompletionStatus } from "../../../Models/End";

export default useArchiveConversationForm;

const archiveConversationSchema = {
  ...defaultEndFormSchema,
  archiveReason: Joi.string().allow(null, "").label("Archive Reason"),
};

export const getArchiveConversationEndActionConfigureData = (
  archiveConversationEndAction,
) => {
  return {
    name: archiveConversationEndAction.name,
    description: archiveConversationEndAction.description,
    completionStatus:
      archiveConversationEndAction?.completionStatus ??
      CompletionStatus.COMPLETED,
    archiveReason:
      archiveConversationEndAction?.archiveReason ?? ArchiveReason.RESOLVED,
  };
};

function useArchiveConversationForm(
  archiveConversationEndAction,
  validationErrors = {},
) {
  const { formState, updateFormState, validate, errors } = useConfigureForm(
    () =>
      getArchiveConversationEndActionConfigureData(
        archiveConversationEndAction,
      ),
    archiveConversationSchema,
    validationErrors,
  );

  return {
    formState,
    updateFormState,
    validate,
    errors,
  };
}
